// extracted by css-extract-rspack-plugin
export default {"switch":"switch-N9pQjW","option":"option-KxGR1X"};